export const registeredPerson = () => ({
    prefix: null,
    firstName: null,
    lastName: null,
    contactPhone: null,
    email: null,
    password: null,
    memberLevel: 'GUEST',
})
